import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { EXTERNAL_LOGIN_URL } from "../../../consts";
import { LexTokenPayload } from "../../../models";
import { loginWithToken } from "../../../store/reducer/_sessionReducer";
import { PDLButton } from "../../components/dna";
import { Logo } from "../../components/global";
import "./index.scss";

const Authenticate = () => {
  const { token } = useParams<{ token: string }>();

  const [expired, setExpired] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!token) {
      setExpired(true);
      return;
    }

    try {
      const decoded = jwtDecode<LexTokenPayload>(token);

      const isExpired = decoded.exp * 1000 < Date.now();

      if (isExpired) {
        setExpired(true);
        return;
      }

      const user = {
        name: decoded.cliente.nome,
        email: decoded.cliente.email,
        origem: decoded.origem,
        idPessoa: decoded.dados.IDPessoa,
      };

      dispatch(
        loginWithToken({
          user,
          token,
        }),
      );

      navigate("/home", { replace: true });
    } catch {
      setExpired(true);
    }
  }, [token, dispatch, navigate]);

  if (expired) {
    return (
      <div className="token-section">
        <Logo variant="lex" />
        <h2>Sessão expirada</h2>
        <p>Seu acesso expirou. Por favor, gere um novo link.</p>

        <PDLButton onClick={() => window.location.replace(EXTERNAL_LOGIN_URL)}>
          Voltar para o site
        </PDLButton>
      </div>
    );
  }

  return (
    <div className="token-section">
      <Logo variant="lex" />
      <h2>Autenticando...</h2>
      <p>Estamos realizando sua autenticação.</p>
    </div>
  );
};

export default Authenticate;
